import React from 'react';
import {AlertTriangle, Download, Plus, RefreshCw, Settings, Shield} from 'lucide-react';

export default function QuickActions() {
    const actions = [
        {
            icon: Plus,
            label: 'Ajouter un site',
            description: 'Nouveau site à surveiller',
            color: 'bg-blue-100 text-blue-600',
            hoverColor: 'hover:bg-blue-600 hover:text-white'
        },
        {
            icon: RefreshCw,
            label: 'Forcer le scan',
            description: 'Vérifier tous les sites',
            color: 'bg-green-100 text-green-600',
            hoverColor: 'hover:bg-green-600 hover:text-white'
        },
        {
            icon: AlertTriangle,
            label: 'Alertes',
            description: '2 alertes non lues',
            color: 'bg-yellow-100 text-yellow-600',
            hoverColor: 'hover:bg-yellow-600 hover:text-white'
        },
        {
            icon: Shield,
            label: 'Sécurité',
            description: 'Vérifier la sécurité',
            color: 'bg-purple-100 text-purple-600',
            hoverColor: 'hover:bg-purple-600 hover:text-white'
        },
        {
            icon: Download,
            label: 'Exporter',
            description: 'Exporter les données',
            color: 'bg-indigo-100 text-indigo-600',
            hoverColor: 'hover:bg-indigo-600 hover:text-white'
        },
        {
            icon: Settings,
            label: 'Paramètres',
            description: 'Configurer le dashboard',
            color: 'bg-gray-100 text-gray-600',
            hoverColor: 'hover:bg-gray-600 hover:text-white'
        }
    ];

    return (
        <div className="bg-white rounded-xl shadow p-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-4">Actions Rapides</h3>
            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                {actions.map((action, index) => {
                    const Icon = action.icon;
                    return (
                        <button
                            key={index}
                            className={`flex flex-col items-center justify-center p-4 rounded-xl border border-gray-200 transition-all duration-200 ${action.hoverColor}`}
                        >
                            <div className={`p-3 rounded-lg ${action.color} transition-colors`}>
                                <Icon className="h-6 w-6" />
                            </div>
                            <span className="mt-3 font-medium text-sm">{action.label}</span>
                            <span className="text-xs text-gray-500 mt-1">{action.description}</span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
